module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-xv"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmt"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Hungarian Pronunciation Guide")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Vowels – Hungarian vowels have approximately the same sounds as do those of other continental European languages. A close vowel is pronounced very close. An acute accent (´) placed over a letter indicates that the vowel is close. Umlauts indicate both quality and quantity of vowel sounds. The short umlaut is made like the German umlaut (¨); the long umlaut is a double acute accent (˝). Vowels are pronounced approximately as follows:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("a like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ou")]), _vm._v(" in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bought")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("á as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("arm")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("e as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("met")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("é like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("a")]), _vm._v(" in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cake,")]), _vm._v(" or French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("thé")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("i like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("e")]), _vm._v(" in the first syllable of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("event")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("í like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("e")]), _vm._v(" in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("eve")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("o as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("obey")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("ó as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("old")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("ö like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("u")]), _vm._v(" in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("church,")]), _vm._v(" or French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("le")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("ő like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("u")]), _vm._v(" in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("urn")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("u like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("u")]), _vm._v(" in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("put")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("ú like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("o")]), _vm._v(" in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("two")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("ü as in German Müller or French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tu")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("ű as in German Führer or French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("rue")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-xvi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Consonants – Except as noted below, consonants have approximately the same value as in English:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("c, cz like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ts")]), _vm._v(" in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fits")]), _vm._v(" or German "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Zug")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cs like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ch")]), _vm._v(" in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("church")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("gy like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("d")]), _vm._v(" plus a glide sound as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("endure")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mon dieu")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("j like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("y")]), _vm._v(" in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("yoke")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("l followed by y or j approximates "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ll")]), _vm._v(" French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fillette")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("s like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sh")]), _vm._v(" in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ship")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("sz like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("s")]), _vm._v(" in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sail")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("y as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("yet")]), _vm._v(", except that final y is equal to i")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("zs like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("s")]), _vm._v(" in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("usual")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Accent – The main stress is always placed on the first vowel in each word.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8d22166a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/guide.vue
// module id = 87
// module chunks = 0